(function () {
  'use strict';

  const root = document.querySelector('.imako-pdp');
  if (!root) return;

  const productDataEl = document.getElementById('imako-product-data');
  if (!productDataEl) return;

  let PRODUCT;
  try {
    PRODUCT = JSON.parse(productDataEl.textContent);
  } catch (e) {
    console.error('[imako] product data parse failed', e);
    return;
  }

  const variants = PRODUCT.variants || [];
  const moneyFormat = PRODUCT.moneyFormat || '${{amount}}';

  function formatMoney(cents) {
    const n = Number(cents) / 100;
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, n.toFixed(2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.toFixed(2).replace('.', ','));
  }

  const state = {
    size: (variants.find((v) => v.available) || variants[0] || {}).option1 || null,
    color: (variants.find((v) => v.available) || variants[0] || {}).option2 || null,
    pack: (variants.find((v) => v.available) || variants[0] || {}).option3 || null,
    qty: 1,
  };

  function findVariant() {
    return variants.find(
      (v) => v.option1 === state.size && v.option2 === state.color && v.option3 === state.pack
    );
  }

  function isCombinationAvailable(opts) {
    return variants.some(
      (v) =>
        v.available &&
        (opts.size == null || v.option1 === opts.size) &&
        (opts.color == null || v.option2 === opts.color) &&
        (opts.pack == null || v.option3 === opts.pack)
    );
  }

  const els = {
    variantId: root.querySelector('[name="id"]'),
    qtyInput: root.querySelector('[name="quantity"]'),
    qtyDec: root.querySelector('[data-qty-dec]'),
    qtyInc: root.querySelector('[data-qty-inc]'),
    priceSubFromHero: root.querySelectorAll('[data-price]'),
    addToCart: root.querySelector('[data-add-to-cart]'),
    addToCartLabel: root.querySelector('[data-add-to-cart-label]'),
    sizeRow: root.querySelector('[data-size-row]'),
    colorRow: root.querySelector('[data-color-row]'),
    packRow: root.querySelector('[data-pack-row]'),
    sizeLabel: root.querySelector('[data-size-label]'),
    colorLabel: root.querySelector('[data-color-label]'),
    packLabel: root.querySelector('[data-pack-label]'),
    form: root.querySelector('form[action*="/cart/add"]'),
  };

  function render() {
    const v = findVariant();

    // option rows
    [els.sizeRow, els.colorRow, els.packRow].forEach((row, idx) => {
      if (!row) return;
      const optionName = ['size', 'color', 'pack'][idx];
      row.querySelectorAll('[data-opt]').forEach((btn) => {
        const value = btn.getAttribute('data-opt');
        btn.classList.toggle('on', state[optionName] === value);
        const probe = { size: state.size, color: state.color, pack: state.pack };
        probe[optionName] = value;
        const ok = isCombinationAvailable(probe);
        btn.toggleAttribute('disabled', !ok);
      });
    });
    if (els.sizeLabel) els.sizeLabel.textContent = state.size || '';
    if (els.colorLabel) els.colorLabel.textContent = state.color || '';
    if (els.packLabel) els.packLabel.textContent = state.pack || '';

    if (!v) {
      if (els.addToCart) els.addToCart.disabled = true;
      if (els.addToCartLabel) els.addToCartLabel.textContent = 'Unavailable';
      return;
    }

    // Update the form's variant id and fire a change event so the
    // Seal Subscriptions widget rebinds to the new variant's plan/price.
    if (els.variantId && els.variantId.value !== String(v.id)) {
      els.variantId.value = v.id;
      els.variantId.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const priceCents = Number(v.price);
    const total = priceCents * state.qty;
    els.priceSubFromHero.forEach((n) => (n.textContent = formatMoney(priceCents)));
    if (els.addToCartLabel) {
      els.addToCartLabel.textContent = 'Add to cart · ' + formatMoney(total);
    }
    if (els.addToCart) {
      els.addToCart.disabled = !v.available;
      if (!v.available && els.addToCartLabel) els.addToCartLabel.textContent = 'Sold out';
    }
  }

  // Option clicks
  root.querySelectorAll('[data-size-row] [data-opt]').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.size = btn.getAttribute('data-opt');
      render();
    });
  });
  root.querySelectorAll('[data-color-row] [data-opt]').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.color = btn.getAttribute('data-opt');
      updateHeroShade();
      render();
    });
  });
  root.querySelectorAll('[data-pack-row] [data-opt]').forEach((btn) => {
    btn.addEventListener('click', () => {
      state.pack = btn.getAttribute('data-opt');
      render();
    });
  });

  // Quantity
  if (els.qtyDec)
    els.qtyDec.addEventListener('click', () => {
      state.qty = Math.max(1, state.qty - 1);
      if (els.qtyInput) els.qtyInput.value = state.qty;
      render();
    });
  if (els.qtyInc)
    els.qtyInc.addEventListener('click', () => {
      state.qty = state.qty + 1;
      if (els.qtyInput) els.qtyInput.value = state.qty;
      render();
    });
  if (els.qtyInput)
    els.qtyInput.addEventListener('change', () => {
      const n = Math.max(1, parseInt(els.qtyInput.value, 10) || 1);
      state.qty = n;
      els.qtyInput.value = n;
      render();
    });

  // Hero shade image swap
  const heroShadeImg = root.querySelector('[data-hero-shade-img]');
  function updateHeroShade() {
    if (!heroShadeImg) return;
    const src =
      state.color && state.color.toLowerCase().indexOf('bleached') > -1
        ? heroShadeImg.getAttribute('data-bleached')
        : heroShadeImg.getAttribute('data-natural');
    if (src && heroShadeImg.getAttribute('src') !== src) heroShadeImg.setAttribute('src', src);
  }

  // Before/After slider — vanilla
  function initBA(el) {
    let clip = 50;
    let dragging = false;
    el.style.setProperty('--clip', clip + '%');
    const note = el.querySelector('.ba-scrubnote');

    function setFromX(clientX) {
      const r = el.getBoundingClientRect();
      const p = Math.max(4, Math.min(96, ((clientX - r.left) / r.width) * 100));
      clip = p;
      el.style.setProperty('--clip', clip + '%');
    }
    function onDown(e) {
      e.preventDefault();
      dragging = true;
      if (note) note.style.opacity = '0';
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      setFromX(x);
    }
    function onMove(e) {
      if (!dragging) return;
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      setFromX(x);
    }
    function onUp() {
      dragging = false;
    }
    el.addEventListener('mousedown', onDown);
    el.addEventListener('touchstart', onDown, { passive: false });
    window.addEventListener('mousemove', onMove);
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchend', onUp);

    // intro animation — scrub side-to-side once on load, then settle at 50
    const start = performance.now();
    function anim(now) {
      if (dragging) return;
      const t = (now - start) / 1000;
      if (t < 2.8) {
        const p = t / 2.8;
        const eased =
          p < 0.33 ? 50 - (p / 0.33) * 38 : p < 0.66 ? 12 + ((p - 0.33) / 0.33) * 76 : 88 - ((p - 0.66) / 0.34) * 38;
        clip = eased;
        el.style.setProperty('--clip', clip + '%');
        requestAnimationFrame(anim);
      } else {
        clip = 50;
        el.style.setProperty('--clip', clip + '%');
      }
    }
    requestAnimationFrame(anim);
  }
  root.querySelectorAll('.ba-wrap[data-ba]').forEach(initBA);

  // Sticky buy-bar
  (function () {
    const el = root.querySelector('.sticky-buy');
    const hero = root.querySelector('.hero');
    if (!el || !hero) return;
    const onScroll = () => {
      const b = hero.getBoundingClientRect();
      el.classList.toggle('on', b.bottom < 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  // Scroll to buy box
  root.querySelectorAll('[data-scroll-to-buy]').forEach((b) => {
    b.addEventListener('click', (e) => {
      e.preventDefault();
      const t = root.querySelector('#imako-buy');
      if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  updateHeroShade();
  render();
})();
